export default {
  text: '#ffffff',
  primary: '#000000',
  secondary: '#202020',
  background: '#480202',
  backgroundSecondary: '#272727',
  light: '#fdfdfd',
  dark: '#202020'
}
